'use strict';

exports.__esModule = true;
exports.fontFamilies = exports.focus = exports.container = exports.column = exports.row = exports.clearfix = exports.media = exports.fonts = exports.colors = undefined;

var _templateObject = _taggedTemplateLiteralLoose(['\n    @media (min-width: ', 'em) {\n      ', '\n    }\n  '], ['\n    @media (min-width: ', 'em) {\n      ', '\n    }\n  ']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n        &:before,\n        &:after {\n            content: " ";\n            display: table;\n        }\n        &:after {\n            clear: both;\n        }\n    '], ['\n        &:before,\n        &:after {\n            content: " ";\n            display: table;\n        }\n        &:after {\n            clear: both;\n        }\n    ']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n        box-sizing: border-box;\n        margin-left: ', 'px;\n        margin-right: ', 'px;\n        ', '\n    '], ['\n        box-sizing: border-box;\n        margin-left: ', 'px;\n        margin-right: ', 'px;\n        ', '\n    ']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n        box-sizing: border-box;\n        position: relative;\n        min-height: 1px;\n        padding-left: ', 'px;\n        padding-right: ', 'px;\n\n        ', '\n    '], ['\n        box-sizing: border-box;\n        position: relative;\n        min-height: 1px;\n        padding-left: ', 'px;\n        padding-right: ', 'px;\n\n        ', '\n    ']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n            float: left;\n            width: ', '%;\n        '], ['\n            float: left;\n            width: ', '%;\n        ']),
    _templateObject6 = _taggedTemplateLiteralLoose(['\n        box-sizing: border-box;\n        margin-right: auto;\n        margin-left: auto;\n        padding-left: ', 'px;\n        padding-right: ', 'px;\n\n        ', '\n\n        ', '\n\n        ', '\n    '], ['\n        box-sizing: border-box;\n        margin-right: auto;\n        margin-left: auto;\n        padding-left: ', 'px;\n        padding-right: ', 'px;\n\n        ', '\n\n        ', '\n\n        ', '\n    ']),
    _templateObject7 = _taggedTemplateLiteralLoose(['\n            width: ', 'px;\n        '], ['\n            width: ', 'px;\n        ']),
    _templateObject8 = _taggedTemplateLiteralLoose(['\n      outline: thin dotted;\n      outline: 5px auto -webkit-focus-ring-color;\n    '], ['\n      outline: thin dotted;\n      outline: 5px auto -webkit-focus-ring-color;\n    ']);

var _styledComponents = require('styled-components');

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var colors = exports.colors = {
    button: {
        primary: {
            default: '#04a2dc',
            selected: '#037EAA',
            disabled: '#C3E3ED'
        },
        secondary: {
            default: '#A0877F',
            selected: '#8d6e63',
            disabled: '#BCAAA3'
        }
    },
    text: {
        primary: {
            default: '#3E2723',
            selected: '#3E2723',
            disabled: '#3E2723'
        },
        secondary: {
            default: '#BCAAA3',
            selected: '#BCAAA3',
            disabled: '#BCAAA3'
        },
        title: {
            brown: '#6E4D40'
        }
    },
    standard: {
        biege: '#C5B3AF'
    },
    background: '#EFEBE9'
};

// TODO: Update with fonts from style guide
var fonts = exports.fonts = {
    primary: 'Helvetica Neue, Helvetica, Roboto, sans-serif',
    pre: 'Consolas, Liberation Mono, Menlo, Courier, monospace',
    quote: 'Georgia, serif',
    bold: 'IntroBold, Helvetica Neue, Helvetica, Roboto, sans-serif',
    book: 'IntroRegular, Helvetica Neue, Helvetica, Roboto, sans-serif'
};

var breakpoints = {
    xs: 480,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200
};

// iterate through the sizes and create a media template
/* eslint-disable */
var media = exports.media = Object.keys(breakpoints).reduce(function (accumulator, label) {
    // use em in breakpoints to work properly cross-browser and support users
    // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
    var emSize = breakpoints[label] / 16;
    accumulator[label] = function () {
        return (0, _styledComponents.css)(_templateObject, emSize, _styledComponents.css.apply(undefined, arguments));
    };
    return accumulator;
}, {});

var clearfix = exports.clearfix = function clearfix() {

    return (0, _styledComponents.css)(_templateObject2);
};

var maximumColumns = 12;

var row = exports.row = function row() {
    var padding = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 15;


    return (0, _styledComponents.css)(_templateObject3, Math.ceil(-padding), Math.floor(-padding), clearfix());
};

var column = exports.column = function column(columns, size) {
    var padding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 15;


    return (0, _styledComponents.css)(_templateObject4, padding, padding, media[size](_templateObject5, 100 * (columns / maximumColumns)));
};

var containerMaxWidths = {
    md: 720,
    xl: 1140
};

var container = exports.container = function container() {
    var padding = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 15;


    return (0, _styledComponents.css)(_templateObject6, Math.floor(padding), Math.ceil(padding), clearfix(), media['md'](_templateObject7, containerMaxWidths['md']), media['xl'](_templateObject7, containerMaxWidths['xl']));
};

var focus = exports.focus = function focus() {

    return (0, _styledComponents.css)(_templateObject8);
};

var fontFamilies = exports.fontFamilies = {
    bold: 'IntroBold',
    regular: 'IntroRegular'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/styledComponentsHelper.js
// module id = 37
// module chunks = 0